import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import React from "react";
import { Message } from "components/Atoms/Message";
import { MergeFieldWithLabel } from "./MergeFieldWithLabel";
import { SectionTemplateHeader } from "./SectionTemplateHeader";
import { MergeFormSection } from "./types";
import { Button } from "semantic-ui-react";
import { PhopshorArrowRight } from "components/Atoms/PhosphorIcon";
import { AxiosPromise } from "node_modules/axios";

interface MergeSectionTemplateProps {
  sourceHeader: JSX.Element
  existingHeader: JSX.Element
  sections: Array<MergeFormSection>
  submit: () => AxiosPromise<server.dto.ApiResponse>
  redirectUrl: string
}

export const MergeSectionTemplate = (props: MergeSectionTemplateProps) => {
  const [serverErrors, setServerErrors] = React.useState<string[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const save = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const response = await props.submit();

    if (response.data.hasErrors) {
      setServerErrors(response.data.errors.map(e => e.message));
      setIsLoading(false);
      return;
    }
    setIsLoading(false);
    setServerErrors([]);

    window.location.href = props.redirectUrl;
  }

  const renderSection = (section: MergeFormSection) => {
    return <React.Fragment key={section.key}>
      <div className="merge-section-template-section-title">{section.title}</div>
      {section.fields.filter(field => !field.hidden).map(field => <MergeFieldWithLabel key={field.key} field={field} />)}
    </React.Fragment>
  }

  return <SectionPanel.Section key="section">
    <SectionPanel.Panel
      key="merge"
      id="merge"
      header={<SectionTemplateHeader>{RESX.OptionsPanel.Merge}</SectionTemplateHeader>}
    >
      <div className="merge-section-template-grid">
        <div title={RESX.GeneralLabels.Information} className="main-section-template-fields-label">{RESX.GeneralLabels.Information}</div>
        <div className="merge-section-template-field">{props.sourceHeader}</div>
        <div className="merge-section-template-field">
          <PhopshorArrowRight iconSize="regular" iconWeight="bold" />
        </div>
        <div className="merge-section-template-field">{props.existingHeader}</div>
        {props.sections.filter(s => !s.hidden).map(section => renderSection(section))}
      </div>
      <div className="flex-column gap">
        {serverErrors.length > 0 && <Message type="error">
          {serverErrors.map((error) => <div key={error}>{error}</div>)}
        </Message>}
        <div className="flex">
          <div className="grow1" />
          <Button
            onClick={save}
            primary
            type="submit"
            loading={isLoading}
            disabled={isLoading}
          >
            {RESX.Buttons.btnSave}
          </Button>
        </div>
      </div>
    </SectionPanel.Panel>
  </SectionPanel.Section>
}
